import './LimitInfo.scss';

const LimitInfo = function(props) {
	let dailyUsage = props.dailyUsage || 0;
	let dailyLimit = props.dailyLimit || 0;
	let monthlyUsage = props.monthlyUsage || 0;
	let monthlyLimit = props.monthlyLimit || 0;

	let daily = dailyLimit ? (<>Daily limit: <b>{dailyUsage}/{dailyLimit}</b></>) : null;
	let monthly = monthlyLimit ? (<>Monthly limit: <b>{monthlyUsage}/{monthlyLimit}</b></>) : null;

	if (daily && monthly) {
		return (
			<p className="limit-info">{daily}<br />{monthly}</p>
		)
	} else {
		let info = daily || monthly;

		return info ? (
			<p className="limit-info">{info}</p>
		) : null;
	}
}

export default LimitInfo;